<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";

// Custom Components
import CompanyForm from "@/components/CompanyForm.vue";
import PageHeader from "@/components/page-header";
import GuestService from "@/helpers/APIService/guest.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Company Component
export default {
  page: {
    title: "Company",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    CompanyForm,
  },
  data() {
    return {
      title: "Company",
      table: {
        tableData: [],
        next: null,
        previous: null,
        count: 10,
        total_pages: 1,
        page_number: 1,
        per_page: 10,
        from: 1,
        to: 10,
      },
      isDataLoading: true,
      isLoading: true,
      openCompanyForm: false,
      selectedCompany: null,
      isEdit: false,
    };
  },
  computed: {
    ...authComputed,
    companyFormProps() {
      return {
        selectedCompany: this.selectedCompany,
        isEdit: this.isEdit,
      };
    },
  },
  methods: {
    // Method is use for get all companies list
    async getCompanies() {
      await GuestService.getCompanyList()
        .then((companies) => {
          this.table.tableData = companies;
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.isLoading = false;
      this.isDataLoading = false;
    },
    // Method is use for open and close company form
    companyForm() {
      if (this.openCompanyForm == true) {
        this.selectedCompany = null;
        this.isEdit = false;
      }
      this.openCompanyForm = !this.openCompanyForm;
    },
    // Method is use for add and update company
    companyAddedUpdated(company) {
      if (this.isEdit == true) {
        this.table.tableData = this.table.tableData.map((obj) => {
          if (obj.id == company.id) {
            obj = company;
          }
          return obj;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.tableData.unshift(company);
        Middleware.notification("Successfully added !!", "success");
      }
      this.companyForm();
    },
    // Method is use for save and add new company continue
    saveAndAddNewCompany(company) {
      this.table.tableData.unshift(company);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for set edit company data
    async edit(data) {
      this.selectedCompany = data;
      this.isEdit = true;
      this.companyForm();
    },
    // Method is use for delete particular company based on company id
    deleteCompany(company_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          GuestService.deleteCompany(company_id)
            .then(() => {
              let index = this.table.tableData.findIndex(
                (el) => el.id === company_id
              );
              this.table.tableData.splice(index, 1);
              Middleware.notification("SuccessFully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :isButton="true"
      :action="companyForm"
      text="Add New Company"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <!-- Table -->
                <div class="table-responsive mb-0" v-dragscroll>
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getCompanies"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Company</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Country</th>
                        <th>City</th>
                        <th>Address</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody
                      id="infinite-list"
                      v-if="table.tableData.length > 0 && !isDataLoading"
                    >
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="edit(data)">
                          {{ data.name }}
                        </td>
                        <td @click="edit(data)">
                          {{ data.mobile }}
                        </td>
                        <td @click="edit(data)">
                          {{ data.email }}
                        </td>
                        <td @click="edit(data)">
                          {{ data.country }}
                        </td>
                        <td @click="edit(data)">
                          {{ data.city }}
                        </td>
                        <td @click="edit(data)">
                          {{ data.address_line_first }}
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success me-1"
                              v-b-popover.hover="'Edit recored'"
                              id="edit"
                              @click="edit(data)"
                            ></i>
                            <i
                              class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                              v-b-popover.hover="'Delete recored'"
                              id="delete"
                              @click="deleteCompany(data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="isDataLoading">
                      <tr v-for="(item, index) in 10" :key="index">
                        <td class="placeholder-glow" v-for="no in 7" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Drawer
      @close="companyForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openCompanyForm">
        <CompanyForm
          :currentProps="companyFormProps"
          @submitted="companyAddedUpdated"
          @cancelSubmit="companyForm"
          @saveAndAddNew="saveAndAddNewCompany"
        ></CompanyForm>
      </div>
    </Drawer>
  </div>
</template>
